import api from '@/lib/api'

const state = () => ({
  all: [],

  headers: {
    list_name: '',
    services: []
  },
})

const getters = {
  all:  state => state.all,
  headers: state => state.headers,

  byCategory: state => {
    let result = {}

    state.all.forEach( service => {
      service.categories.forEach( category => {
        if (category.name in result) {
          result[category.name].push(service)
        } else {
          result[category.name] = [service]
        }
      })
    })

    return result
  },

  categories: (_state, getters) => Object.keys(getters.byCategory).sort(),

  onlyCategory: (_state, getters) => category => {
    getters.byCategory[category]
  },
}

const actions = { 
  async loadAll({ commit }) {
    const result = await api.get('/services')
    if (result.ok) {
      commit('SET_ALL', await result.json())
      return { ok: true }
    } 
 
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadHeaders({ commit }) {
    const result = await api.get('/services/headers')
    if (result.ok) {
      commit('SET_HEADERS', await result.json())
      return { ok: true }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },
}

const mutations = { 
  SET_ALL: (state, services) => state.all = services,
  SET_HEADERS: (state, headers) => state.headers = headers,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}